import axios from "axios";
import { store } from '@/store';
import router from '@/router';
import i18n from "@/lang";

import {
  setToken,
  setUsername,
  getToken,
  getUsername,
  removeToken,
  removeUsername,
  setTokentype,
  getTokentype,
  removeTokentype,
} from "@/utils/cookies";

const env = import.meta.env;

const language = (navigator.language || 'zh').toLocaleLowerCase() // 这是获取浏览器的语言
console.log("i18n.global.locale.value",i18n.global.locale.value);
//创建实例
const service = axios.create({
  baseURL: "/api", //请求地址
  timeout: 600000, //超时
  // 延时后重新请求次数
  retry: 5,
  //延时后重新请求间隔
  retryInterval: 1000,
  // 设置请求头
  headers: {
    'Content-Type': 'application/json',
    // 'Authorization': `Bearer ${token}`,
    'locale': i18n.global.locale.value,//localStorage.getItem('lang') || language.split('-')[0] || 'zh',
  },
  responseType: 'json',
});

// service.defaults.headers.common['Authorization'] = `Bearer ${token}`;
// async request => {
//     console.log(request,"request");
//     // request.headers['Authorization'] = `Bearer ${token}`
//   },
//添加请求拦截器
service.interceptors.request.use(
  function (config) {
    // console.log(config,"config");
    // 在发送请求之前做些什么
    config.headers.locale = i18n.global.locale.value;

    if (getToken()) {
      config.headers["Authorization"] = 'Bearer '+getToken(); //携带token Token可以和后端约定
    }
   // + if (getUsername()) {
   //    config.headers["Username"] = getUsername();//Username可以和后端约定
   //  }

    return config;
  },
  function (error) {
    // console.log(error.request);
    const errorData = JSON.parse(error.request.response);
    if (errorData.message) {
      // 判断是否具有message属性
      console.log(errorData.message)
      // ElMessage({
      //   message: errorData.message,
      //   type: "error",
      // });
    }
    //对请求错误做些什么
    return Promise.reject(errorData);
  }
);
 
// 递归处理数据，将 file:// 替换为 http://
function replaceFileProtocol(obj) {
  if (typeof obj === 'string') {
    return obj.replace(/file:\/\//g, 'http://');
  }
  if (Array.isArray(obj)) {
    return obj.map(item => replaceFileProtocol(item));
  }
  if (obj !== null && typeof obj === 'object') {
    const newObj = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        newObj[key] = replaceFileProtocol(obj[key]);
      }
    }
    return newObj;
  }
  return obj;
}

//添加响  应拦截器
service.interceptors.response.use(
  function (response) {
    //对响应数据做些什么
    // console.log("响应数据", response);
    const status = response.status;
    if (status === 200) {
      if (response.data) {
        response.data = replaceFileProtocol(response.data);
      }
      return Promise.resolve(response.data);
    } else {
      // ElMessage({
      //   message: '数据获取失败',
      //   type: "error",
      // });
      console.log('数据获取失败')
      return Promise.reject(data);
    }
  },
  function (error) {
    //对响应错误做些什么
    const errorData = JSON.parse(error.request.response);
    if (errorData.message) {
      //判断是否具有message属性
      console.log(errorData.message)
      // ElMessage({
      //   message: errorData.message?errorData.message:'链接中断',
      //   type: "error",
      // });
    }
 
    return Promise.reject(errorData);
  }
);
 
//暴露service
export default service;